import { cn } from '@dreamstack/util/src/cn'
import Link from 'next/link'
import { IS_ACCENTRO_WEB } from '../config/config'
import { NavbarLogoSvg } from './NavbarLogoSvgComponent'

// FROM: https://codepen.io/sosuke/pen/Pjoqqp (#508090)
type NavBarLogoProps = {
  forceDarkTextColor: boolean
  href?: string
}

export const NavBarLogo = ({
  forceDarkTextColor,
  href = '/',
}: NavBarLogoProps) => {
  const logoClass = cn(
    'text-accentroWhite-full',
    forceDarkTextColor && 'text-accentroGray-full',
    forceDarkTextColor && IS_ACCENTRO_WEB && 'text-accentroAqua-full'
  )
  return (
    <div className="z-10">
      <Link href={href} passHref aria-label="Go to homepage">
        <div className="w-[153px] sm:w-px-196 md:w-[230px] flex">
          <NavbarLogoSvg className={logoClass} />
        </div>
      </Link>
    </div>
  )
}
